import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Button, Modal, ModalFooter } from 'react-bootstrap'
import Card from '../../components/Card'
import { Link, useNavigate, Route } from 'react-router-dom'
import { apiHandler } from '../../api/apihandler';
import { TEACHERS_RESULTS_LIST_STUDENT_API, TEACHERS_RESULTS_LIST_SHARE_API } from "../../api/constants";
import Moment from 'moment';
import { InView } from "react-intersection-observer";
import NoDataFound from '../noDataFound';
import loader from '../../assets/images/page-img/page-load-loader.gif'
import Swal from 'sweetalert2'


const ShareModal = ({ handleClose, classId, data }) => {
    const navigate = useNavigate();
    const [studentsList, setStudentsList] = useState([]);
    const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
    const [isFirst, setIsFirst] = useState(true);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);

    const [selectedStudents, setSelectedStudents] = useState([]);

    const handleCheckboxChange = (userId) => {
        setSelectedStudents(prev => {
            const updated =
                prev.includes(userId)
                    ? prev.filter(id => id !== userId)
                    : [...prev, userId];
            // Log the updated array after state is set
            setTimeout(() => {
                console.log("Selected Students: ", updated);
            }, 0);
            return updated;
        });
    };

    const loadMore = (inView) => {
        if (inView) {
            if (page < maxPage) {
                getResponseStudentApi(page + 1);
                //console.log("scroll working...", page + 1)
                setPage(page + 1)
            }
        }
    };

    function refreshApi() {
        setPage(1)
        getResponseStudentApi(1);
    }

    useEffect(() => {
        getResponseStudentApi(1);
    }, []);

    useEffect(() => {
        // Preselect students where is_shared is true
        if (studentsList.length > 0) {
            const sharedIds = studentsList
                .filter(elm => elm?.is_shared)
                .map(elm => elm?.user?.id);
            setSelectedStudents(sharedIds);
        }
    }, [studentsList]);

    async function getResponseStudentApi(pageVal) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_RESULTS_LIST_STUDENT_API, "POST", {
                page: pageVal,
                limit: 100,
                class_id: classId,
                ai_search_id: data?.ai_search_id
            })
            if (res.data?.response?.status === 200) {
                setMaxPage(res?.data?.data?.students?.meta?.last_page)
                if (res.data?.response?.status === 200) {
                    if (pageVal === 1) {
                        setStudentsList(res?.data?.data?.students || []);
                    } else {
                        setStudentsList(studentsList.concat(res?.data?.data?.students))
                    }
                }

            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getShareResponseApi() {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_RESULTS_LIST_SHARE_API, "POST", {
                classId: classId,
                aiSearchId: data?.ai_search_id,
                studentId: selectedStudents
            })
            if (res.data?.response?.status === 200) {
                Swal.fire({
                    title: 'Success',
                    text: res.data?.data?.message || 'Data shared successfully!',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                })
                // setApiResponseText('');
                // setEditMode(false);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    return (
        <Modal scrollable={true} show={true} onHide={handleClose} size="lg" style={{ marginTop: 80 }}>
            <Modal.Header className="d-flex justify-content-between">
                <div className="d-flex justify-content-between">
                    <div className="w-100">
                        <div className="d-flex justify-content-between flex-wrap">
                            <div>
                                <h5 className="mb-0 d-inline-block"><Link to="#">Share {data?.ai_search?.purpose}</Link></h5>
                                {/* <p className="mb-0">{Moment(elm?.created_at).format('DD MMMM YYYY')}</p> */}
                            </div>
                        </div>
                    </div>
                </div>
                <button type="button" className="btn btn-secondary lh-1" onClick={handleClose} ><span className="material-symbols-outlined">close</span></button>
            </Modal.Header>
            <Modal.Body>
                <div className="post-item" style={{ maxHeight: "500px" }}>
                    {
                        studentsList.length > 0 ?
                            <ul className="request-list m-0 p-0">
                                {studentsList.map((elm, i) => (
                                    <li key={elm?.id} className="d-flex  flex-wrap">
                                        <div className="user-img img-fluid flex-shrink-0">
                                            <img src={elm?.user?.user_setting?.photo ? elm?.user?.user_setting?.photo : "https://uzone360live.s3.amazonaws.com/noimage.png"}
                                                alt="story-img" className="rounded-circle avatar-40" />
                                        </div>
                                        <div className="flex-grow-1 ms-3">
                                            <Link to={`/dashboard/app/friend-profile/${elm?.user?.slug}`}>
                                                <h5>{elm?.user?.first_name && (elm?.user?.first_name + " " + elm?.user?.last_name)}</h5>
                                            </Link>
                                        </div>
                                        <div className="d-flex align-items-center mt-2 mt-md-0">
                                            <input
                                                type="checkbox"
                                                checked={selectedStudents.includes(elm?.user?.id)}
                                                onChange={() => handleCheckboxChange(elm?.user?.id)}
                                            />
                                        </div>
                                    </li>
                                ))}
                            </ul> : <NoDataFound txtData="No results found yet!" />
                    }
                    <InView as="div" onChange={(inView, entry) => loadMore(inView)} />
                </div>
            </Modal.Body>
            <ModalFooter>
                <div className="w-100" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button
                        onClick={() => getShareResponseApi()}
                        style={{
                            background: 'linear-gradient(90deg, #00c6ff 0%, #0072ff 100%)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '15px',
                            padding: '7px 18px',
                            fontSize: '15px',
                            // fontWeight: 'bold',
                            boxShadow: '0 4px 16px rgba(0,114,255,0.15)',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}
                    >
                        <span className="material-symbols-outlined" style={{ fontSize: 20 }}>share</span>
                        Share
                    </button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default ShareModal